<script setup>
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import PopinComptePro from "@/components/organisms/popins-compte/popin-compte-pro";

import {
  ActionTypes,
  StatusTypes,
  useCheckoutProStore
} from "@/store/checkout-pro";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";
import ananas from "@/assets/images/ananas.svg";

definePageMeta({
  layout: "commander-pro",
  middleware: "tunnel-pro"
});

const { status, error } = storeToRefs(useCheckoutProStore());
const { isMobile } = storeToRefs(useContextStore());
const { resetError } = useCheckoutProStore();
const { magasin } = storeToRefs(useMagasinStore());

const errorMessage = computed(() => {
  if (!error.value) {
    return "";
  }
  if (error.value.status_code === 500 || !error.value.message) {
    return "Une erreur inattendue est survenue.";
  } else if (error.value.status_code === 404) {
    return "Vous avez dépassé le délai imparti à la validation de votre commande, nous avons dû rafraichir vos informations.";
  }
  return error.value.message;
});
const showPopinError = computed(() => {
  return (
    (error.value && error.value.status_code === 404) ||
    (status.value.type === StatusTypes.CHECKOUT_ERROR &&
      status.value.action === ActionTypes.CREATE)
  );
});
const needGoPanier = computed(() => {
  return (
    (status.value.type === StatusTypes.CHECKOUT_ERROR &&
      status.value.action === ActionTypes.CREATE) ||
    (error.value && error.value.status_code === 500)
  );
});

const redirectAfterError = async () => {
  if (needGoPanier.value) {
    navigateToInternal("/panier", { replace: true });
  } else if (error.value && error.value.status_code === 422) {
    resetError();
  } else {
    window.location.reload(true);
  }
};

const hasServicePro = computed(() => {
  return magasin.value?.attributes.service_corapro;
});
</script>

<template>
  <div>
    <NuxtPage />
    <PopinComptePro
      :visible="!hasServicePro"
      :magasin="magasin"
      no-service
      @hidden="navigateToInternal('/panier', { replace: true });"
    />
    <Popin
      ref="popinError"
      :visible="showPopinError && hasServicePro"
      size="md"
      aria-label="Oups! Une erreur s’est produite"
      :slide-up="isMobile"
      @closed="redirectAfterError()"
    >
      <p class="u-text-center">
        <LazyImage
          :src="ananas"
          width="100"
          height="95"
          alt=""
          class="u-inline-block"
        />
      </p>
      <h2 class="u-font-secondary u-color-primary u-font-700 u-font-24 u-text-center u-mb-sm">
        Oups! <span class="u-none u-inline@sm"><br></span>Une erreur s’est produite
      </h2>
      <div
        v-if="error"
        class="u-mb-md"
      >
        <p class="u-font-15 u-text-center u-mb-sm">
          {{ errorMessage }}
        </p>
      </div>
      <div class="u-text-center">
        <Button
          variant="primary"
          radius="full"
          size="md"
          @click="$refs.popinError.hide()"
        >
          <template v-if="needGoPanier">
            Retour au panier
          </template>
          <template v-else>
            Ok j'ai compris
          </template>
        </Button>
      </div>
    </Popin>
  </div>
</template>
